import React from 'react';

// Small label/value row used in the mobile card layouts (invoicing
// reconciliation + invoiced summary). Keeps the two cells on separate lines so
// they render cleanly stacked on small screens.
function KeyValueRow({ label, value, emphasis = false }) {
  return (
    <div className={`d-flex justify-content-between${emphasis ? ' fw-semibold' : ' small'}`}>
      <span className={emphasis ? '' : 'text-muted'}>{label}</span>
      <span>{value}</span>
    </div>
  );
}

export default KeyValueRow;
